<template>
  <b-modal
    id="semantic-modal"
    v-model="show" 
    ok-only
    no-fade
    button-size="lg"
    size="lg"
    @show="modalShow"
    @ok="runCharuzit"
    @close="onCancel"
    body-class="pb-0"
    footer-class="position-relative"
    :header-close-content="hebrew ? '&#x279C;' : '&larr;'"
    :title="hebrew ? 'חיפוש מתקדם' : 'Advanced search'"
    :ok-title="hebrew ? 'בצע' : 'Ok'"
  >
    <div class="advanced-settings-mobile-wrap h-100">
      <SemanticSearch @word-selected="setSemanticWord" @word-removed="wordRemoved"/>
      <RhymeSettings v-if="searchModel==='rhyme'"></RhymeSettings>
      <AccentSettings v-if="searchModel==='tavnit'"></AccentSettings>
    </div>
  </b-modal>
</template>
<script>
  import SemanticSearch from '@/components/SemanticSearch'
  import RhymeSettings from '@/components/rhymeSettings'
  import AccentSettings from '@/components/AccentSettings'
  import {Actions} from '@/store/stateChanges'
  export default {
    name: 'MobileSemantic',
    data() {
      return {
        semanticWord: '',
        itemsToRemove: [],
        addedWords: []
      }
    },
    components: {
      SemanticSearch,
      RhymeSettings,
      AccentSettings
    },
    props: ["value"],   
    methods: {
      onCancel () {
        this.itemsToRemove.forEach(element => {
          this.$store.commit('INSERT_SEMANTIC_WORD',  element)
        })
        this.itemsToRemove = []
        this.addedWords.forEach(element => {
          let index = this.semanticSelectedWords.indexOf(element)
          this.$store.commit('REMOVE_SEMANTIC_ITEM',  index)          
        })
        this.addedWords = []
      },
      setSemanticWord (word) {
        this.addedWords.push(word)
        this.semanticWord = word
        setTimeout(() => {
          document.activeElement.blur()
          document.getElementById('semantic-modal').getElementsByTagName("BUTTON")[2].focus()        
        },20)
      },
      wordRemoved (word) {
        this.itemsToRemove.push(word)
      },
      runCharuzit () {        
        this.$store.dispatch(Actions.RUN_CHARUZIT)
      },
      modalShow () {
        history.pushState('', document.title, window.location.pathname + window.location.search)
      }
    },
    computed: {
      hebrew () {
        return this.$settings.hebrew
      },
      semanticSelectedWords: function() {
        return this.$store.state.semanticKeywordsArr
      },
      searchModel () {
        return this.$store.state.searchModel
      },         
      show: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit("input", value);
        }
      }
    },        
  }
</script>
<style lang="scss">
  .advanced-settings-mobile-wrap {
    overflow-y: auto;
    overflow-x: hidden;
    
  }
  #semantic-modal{
    .modal-dialog {
      height: 100%;
      direction: ltr;
      margin: 0;      
    }
    .modal-body {
      background: white;
      height: 69vh;      
       @media screen and (orientation:landscape) { 
          //height: auto;
          height: 60%;
          flex: none;
          padding-bottom: 0;
       }
    }
    .modal-content {      
      width: 360px!important;
      max-width:97%!important;
      min-width: 330px;
      min-height: 300px;      
      @media screen and (orientation:landscape) { 
        min-height: 0;
        width: 75%!important;
        .modal-footer {
          padding-top: 5px;
        }
      }
      height: 100%;
      direction: rtl;   
    }
    .modal-header {
      padding-right: 37px;
      padding-left: 37px;      
      h5{
        font-size: 16px;
      }
    }
    .close {
      opacity: 1; 
      padding: 0;
      position: absolute;
      right: 30px;
      top: 19px;
      font-size: 19px;
      text-shadow: none;
      font-weight: 300;
    }
    .modal-footer {
      background: white;
      border-top: solid 1px #c8c8c8;
      box-shadow: 0 -2px 2px 0 rgba(0, 0, 0, 0.07);
    }
    .btn-primary {
      width: 100%;
      height: 48px;
      font-size: 22px;
      border-radius: 2px;
    }
    .b-popover-dark {
      border: none;
      box-shadow: none;  
      .popover-body{
        background: #4a5057;
        color: white;
        border-radius: 6px;
      }
      &.bs-popover-bottom > {
        .arrow {
          top: -.5rem;
          &::after, &::before {
            border-bottom-color: #4a5057;        
          }
        }
      }
    }    
  }
    
</style>